module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.e6cf7c6e.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/font-awesome-4.6.3/fonts/fontawesome-webfont.woff2?v=4.6.3
 ** module id = 1360
 ** module chunks = 0
 **/